"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var TTableSelectPreset_1 = __importDefault(require("./TTableSelectPreset"));
var TTableSavePreset_1 = __importDefault(require("./TTableSavePreset"));
var react_intl_1 = require("react-intl");
var TTableSettingsPreset_1 = __importDefault(require("./TTableSettingsPreset"));
var TTableAutoSavePreset_1 = __importDefault(require("./TTableAutoSavePreset"));
function TTablePresets(props) {
    var _this = this;
    var isVisible = props.isVisible, registryCode = props.registryCode, initialState = props.initialState, tableState = props.tableState, visibleColumns = props.visibleColumns, presetsSetting = props.presetsSetting, onChangeTableState = props.onChangeTableState, lang = props.lang, saveListPresets = props.saveListPresets, fetchUserRoleList = props.fetchUserRoleList, isAdmin = props.isAdmin, loadData = props.loadData;
    var listPreset = presetsSetting.listPreset, savePreset = presetsSetting.savePreset, deletePreset = presetsSetting.deletePreset, getLastPresetId = presetsSetting.getLastPresetId, setLastPreset = presetsSetting.setLastPreset;
    var intl = react_intl_1.useIntl();
    var byDefaultMessage = react_1.useMemo(function () { return intl.formatMessage({ id: 'ttable.byDefault', defaultMessage: 'По умолчанию' }); }, [intl, lang]);
    var defaultPreset = react_1.useMemo(function () { return ({
        id: 'default',
        shared: false,
        default: false,
        autoSaved: false,
        registryCode: registryCode,
        title: byDefaultMessage,
        data: initialState,
        sharedRules: [],
    }); }, [registryCode, byDefaultMessage, initialState]);
    var _a = react_1.useState([]), customPresets = _a[0], setPresets = _a[1];
    var presets = react_1.useMemo(function () { return __spreadArrays([defaultPreset], customPresets); }, [defaultPreset, customPresets]);
    var _b = react_1.useState(defaultPreset === null || defaultPreset === void 0 ? void 0 : defaultPreset.id), currentPresetId = _b[0], setCurrentPresetId = _b[1];
    var currentPreset = react_1.useMemo(function () {
        return presets.find(function (_) { return _.id === currentPresetId; }) || defaultPreset;
    }, [presets, currentPresetId]);
    var _c = react_1.useState(true), isLoading = _c[0], setIsLoading = _c[1];
    var loadPresets = react_1.useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var presets, lastPresetId, lastPreset, byDefaultPreset, defaultPresets;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    return [4 /*yield*/, listPreset(registryCode)];
                case 1:
                    presets = _a.sent();
                    return [4 /*yield*/, getLastPresetId(registryCode)];
                case 2:
                    lastPresetId = _a.sent();
                    lastPreset = presets.find(function (p) { return p.id === lastPresetId; });
                    if (lastPreset) {
                        byDefaultPreset = lastPreset;
                    }
                    else {
                        defaultPresets = presets
                            .filter(function (item) { return item.default; })
                            .sort(function (a, b) { return (a.title[0].toLocaleLowerCase() > b.title[0].toLocaleLowerCase() ? 1 : -1); });
                        byDefaultPreset = defaultPresets[0] || null;
                    }
                    setPresets(presets);
                    !isAdmin && byDefaultPreset && handleChangePreset(byDefaultPreset);
                    loadData();
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, [listPreset, registryCode]);
    react_1.useEffect(function () {
        if (!isLoading) {
            loadData();
        }
    }, [loadData, lang, isLoading]);
    var handleChangePreset = react_1.useCallback(function (preset) {
        setCurrentPresetId(preset.id);
        setLastPreset(preset);
        if (preset.data) {
            onChangeTableState(preset.data);
        }
        else {
            onChangeTableState(initialState);
        }
    }, [onChangeTableState, setCurrentPresetId, initialState]);
    var handleDeletePreset = react_1.useCallback(function (p) {
        if (p.id) {
            deletePreset(p.id).then(function () {
                setPresets(function (presets) { return presets.filter(function (_) { return _.id !== p.id; }); });
            });
        }
        if (p.id === currentPresetId) {
            setCurrentPresetId(defaultPreset.id);
            handleChangePreset(defaultPreset);
        }
    }, [deletePreset, currentPresetId, setCurrentPresetId, defaultPreset, handleChangePreset]);
    var handleSavePreset = react_1.useCallback(function (preset) {
        setPresets(function (prevState) {
            var oldPreset = prevState.find(function (_) { return _.id === preset.id; });
            if (oldPreset) {
                return prevState.map(function (p) { return (p.id === preset.id ? preset : p); });
            }
            return __spreadArrays(prevState, [preset]);
        });
        setCurrentPresetId(preset.id);
        setLastPreset(preset);
    }, [setCurrentPresetId, setPresets]);
    react_1.useEffect(function () {
        loadPresets();
    }, []);
    return isVisible ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Grid, { container: true, spacing: 4, alignItems: "center", wrap: "nowrap" },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 6 },
                react_1.default.createElement(TTableSelectPreset_1.default, { presets: presets, currentPreset: currentPreset, onDeletePreset: handleDeletePreset, onChangePreset: handleChangePreset, isAdmin: isAdmin })),
            isAdmin && (react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(TTableSettingsPreset_1.default, { presets: presets, fetchUserRoleList: fetchUserRoleList, saveListPresets: saveListPresets, loadPresets: loadPresets, isLoading: isLoading }))),
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(TTableSavePreset_1.default, { registryCode: registryCode, allPresets: presets, tableState: tableState, savePreset: savePreset, onSavePreset: handleSavePreset, visibleColumns: visibleColumns, isAdmin: isAdmin }))),
        react_1.default.createElement(TTableAutoSavePreset_1.default, { presets: presets, currentPreset: currentPreset, registryCode: registryCode, tableState: tableState, savePreset: savePreset, onSavePreset: handleSavePreset, visibleColumns: visibleColumns }))) : null;
}
exports.default = TTablePresets;
